import * as React from 'react'
import {Box} from '../../webui/Box'
import {Typography} from '../../webui/Typography'

export interface LocationTranslationProps {
  description: string
  lng: 'da' | 'en' | 'no' | 'sv'
}

const lineStyle = {display: 'flex', alignItems: 'center'}
const titleStyle = {fontWeight: 600}
const valueStyle = {}
export const LocationTranslation: React.FC<LocationTranslationProps> = ({description, lng}) => (
  <Box mt={2} display={'flex'} alignItems={'center'}>
    <img src={`/flags/flag-${lng}.svg`} alt={`flag-${lng}`} width={20} height={20} />
    <Box ml={1}>
      <Typography variant="body2">
        <span style={{...lineStyle}}>
          <div style={titleStyle}>Description:&nbsp;</div>
          <div style={valueStyle}>{description ? description : '(not set)'}</div>
        </span>
      </Typography>
    </Box>
  </Box>
)
